import { useEffect, useState } from "react"
import theme from "app/theme"

const useIsMobile = () => {
  const mobileWidth = parseInt(theme.breakpoints.mobile)
  const [isMobile, setIsMobile] = useState(window.innerWidth <= mobileWidth)

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= mobileWidth)
    window.addEventListener("resize", handler)
    return () => window.removeEventListener("resize", handler)
  }, [mobileWidth])

  return isMobile
}

export default useIsMobile